import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import AssetLogo from 'sections/AssetLogo';
import { Underwriter, useGetUnderwriterMemberInfoQuery } from 'graphql/types';
import CustomTooltip from 'components/CustomTooltip';

interface McaUnderwriterWidgetProps {
  underwriter?: Underwriter;
  onClick?: () => void;
  useCompactView?: boolean;
}

const McaUnderwriterWidget: React.FC<McaUnderwriterWidgetProps> = ({
  underwriter,
  useCompactView = false,
}) => {
  const { data } = useGetUnderwriterMemberInfoQuery({
    skip: !underwriter?.id || !!underwriter?.logo,
    variables: { underwriterId: underwriter?.id as string },
  });

  const members = data?.getUnderwriterMemberInfo || [];

  if (!underwriter) return null;

  const logos = underwriter?.logo
        ? [{ logo: underwriter.logo, name: underwriter.name || '', isPublic: true }]
        : members.length > 0
            ? members.slice(0, 3).map((m) => ({
                logo: m?.avatar || undefined,
                name: m?.name || '',
                isPublic: false
            }))
            : [{ logo: undefined, name: underwriter?.code || '?', isPublic: false }];

  return (
    <Stack direction="row" alignItems="center" flex={1} mt={0.25} mb={useCompactView ? 0 : 0.5}>
      <Stack
        minWidth={useCompactView ? "32px" : "42px"}
        flexShrink={0}
        direction="row"
        alignItems="center"
        sx={{ overflow: 'visible' }}
      >
        {logos.length > 1 ? (
          <Stack direction="row" sx={{ overflow: 'visible', mr: 1 }}>
            {logos.map((item, i) => (
              <span
                key={i}
                style={{
                  display: 'inline-block',
                  position: 'relative',
                  zIndex: i + 1,
                  marginLeft: i === 0 ? 0 : -10,
                }}
              >
                <AssetLogo logo={item.logo} name={item.name} size={useCompactView ? "xs" : "sm"} isPublic={item.isPublic} />
              </span>
            ))}
          </Stack>
        ) : (
          <AssetLogo logo={logos[0].logo} name={logos[0].name} size={useCompactView ? "xs" : "sm"} isPublic={logos[0].isPublic} />
        )}
      </Stack>
      <Stack spacing={0.5} alignItems="flex-start" width="100%">
        <CustomTooltip
          title={underwriter?.name}
          placement="top"
          PopperProps={{
            sx: { '& .MuiTooltip-tooltip': { bgcolor: '#000000' } },
          }}
        >
          <Typography
            sx={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              fontSize: useCompactView ? "11px !important" : "12px !important",
              lineHeight: 1.3,
              maxWidth: '120px',
            }}
          >
            {underwriter?.code}
          </Typography>
        </CustomTooltip>
      </Stack>
    </Stack>
  );
};

export default McaUnderwriterWidget;
